import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"
import { apiUrl, getByAxios } from "../helpers/axios.js"
import { currentLocation } from "../helpers/location.js"

export default class extends Controller {
  initialize () {
    // Is run first. In this case we don't need to worry about anything.
  }

  connect() {

    let realtimePartialController = this;

    this.subscription = consumer.subscriptions.create(
      {
        channel: "RealtimePartialChannel",
        key: this.data.get("key")
      },
      {
        connected() {
          // Called when the subscription is ready for use on the server
        },
        disconnected() {
          // Called when the subscription has been terminated by the server
        },
        received(data) {
          realtimePartialController.renderPartial(data);
        }
      }
    );
  }

  disconnect() {
    this.subscription.unsubscribe();
  }

  renderPartial(data) {
    if (data['body'] == 'refresh') {
      try {
        $("#index-loader").show()
        $.ajax({ url: currentLocation('js'), contentType: 'text/javascript' })
      } catch (error) {

      }
    } else if (data['selector']) {
      let newBody = this._parseHTMLResponse(data['body'])
      if (data['delete'] === 'delete') {
        document.querySelectorAll(data['selector']).forEach(e => e.remove());
      } else if (data['insert'] === 'insert') {
        document.querySelectorAll(data['selector'])[0].prepend(newBody)
      } else {
        document.querySelectorAll(data['selector']).forEach((el, index) => {
          el.innerHTML = data['body']
        })
      }
    } else {
      let newBody = this._parseHTMLResponse(data['body']);
      // Replace all data-turbolinks-permanent elements in the body with what was there
      // previously. This is useful for elements the user might interact with, such
      // as forms or dropdowns.
      let permanentNodes = this.element.querySelectorAll("[id][data-turbolinks-permanent]");
      permanentNodes.forEach(function(element){
        var oldElement = newBody.querySelector(`#${element.id}[data-turbolinks-permanent]`)
        oldElement.parentNode.replaceChild(element, oldElement);
      });

      // Remove all the current nodes from our element.
      while( this.element.firstChild ) { this.element.removeChild( this.element.firstChild ); }

      // When we're sending a new partial, which is a full replacement of our
      // element & not just a group of children.
      if( newBody.childElementCount === 1 && newBody.firstElementChild.dataset.realtimePartialKey === this.data.get("key") ){
        while( newBody.firstElementChild.firstChild ) { this.element.appendChild( newBody.firstElementChild.firstChild ); }
      } else {
        // Append the new nodes.
        while( newBody.firstChild ) { this.element.appendChild( newBody.firstChild ); }
      }
    }

  }

  // From: https://stackoverflow.com/a/42658543/445724
  // using .innerHTML= is risky. Instead we need to convert the HTML received
  // into elements, then append them.
  // It's wrapped in a <template> tag to avoid invalid (e.g. a block starting with <tr>)
  // being mutated inappropriately.
  _parseHTMLResponse(responseHTML){
    let parser = new DOMParser();
    let responseDocument = parser.parseFromString( `<template>${responseHTML}</template>` , 'text/html');
    let parsedHTML = responseDocument.head.firstElementChild.content;
    return parsedHTML;
  }
}
